import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {BatchTransferReportData} from "./batch-transfer-report.data";

@Injectable()
export class BatchTransferReportModel extends ReportModel<BatchTransferReportData> {
    constructor(injector: Injector) {
        super(injector, BatchTransferReportData)
    }
}
